import React, { useEffect } from 'react';
import config from 'react-global-configuration';

interface FacebookPixelProps {
  pixelId?: string;
  action: string;
  details?: any;
}

// Extend the Window interface to include fbq.
declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
  }
}

/**
 * FacebookPixel component loads the Facebook Pixel script, initializes it with the given pixel ID,
 * and sends a PageView event.
 */
const FacebookPixel: React.FC<FacebookPixelProps> = ({ pixelId, action, details }) => {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    // If fbq already exists, don't load the script again.
    if (!window.fbq) {
      // Insert the fbq initialization code.
      (function(f: any, b: any, e: any, v: string, n?: any, t?: any, s?: any) {
        if (f.fbq) return;
        n = f.fbq = function(...args: any[]) {
          if (n.callMethod) {
            n.callMethod(...args);
          } else {
            n.queue.push(args);
          }
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = true;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    }

    // Initialize the Pixel and track the PageView
    if (!pixelId) {
      pixelId = config.get("facebook.pixelId")
    }
    if (pixelId) {
      window.fbq && window.fbq('init', pixelId);
      window.fbq && window.fbq('track', action, details);
      console.log(`Facebook Pixel: ID=${pixelId} Action=${action}`, details)
    } else {
      console.log(`Facebook Pixel: ID=None Action=${action}`, details)
    }
  }, [pixelId, action]);

  // This component doesn't render any visible element.
  return null;
};

export default FacebookPixel;